import React, {useState} from 'react';
import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import {Spinner} from 'react-bootstrap';
import {ContainerOptions, Explanation, InputError, InputOption, InputSend, LabelCart} from './cuenta.elements';
import {resendRegistrationCode, verifyRegistrationCode} from '../infrastructure/UserApi';
import {isFailure, isPending, isSuccess} from '../../common/domain/RemoteData.model';

/**
 * Paso 2 del alta: el solicitante introduce el código de 6 dígitos que se le ha enviado al email.
 * Hasta que lo introduce, la empresa no recibe la solicitud. La autorización sigue siendo manual.
 */
export const VerificationCodeStep = ({ registration, tenantId, onVerified }) => {
  const [result, setResult] = useState(null);
  const [resend, setResend] = useState(null);

  const schema = Yup.object({
    codigo: Yup.string().matches(/^\d{6}$/, 'El código son 6 dígitos').required('Introduce el código')
  });

  const submit = async ({ codigo }) => {
    setResult({ state: 'pending' });
    const remote = await verifyRegistrationCode({ id: registration.id, codigo }, tenantId);
    setResult(remote);
    if (isSuccess(remote)) onVerified();
  };

  const handleResend = async () => {
    setResend({ state: 'pending' });
    setResend(await resendRegistrationCode({ id: registration.id }, tenantId));
  };

  return (
    <Formik initialValues={{ codigo: '' }} validationSchema={schema} onSubmit={submit}>
      {({ handleChange, handleBlur, values, errors, touched }) => (
        <Form>
          <p>
            Te hemos enviado un código de 6 dígitos a <strong>{registration.email}</strong>. Introdúcelo para confirmar
            que el correo es tuyo; solo entonces revisaremos tu solicitud.
          </p>
          <div className="row">
            <ContainerOptions className="col-md-5">
              <LabelCart className="mandatory">Código de verificación</LabelCart>
              <InputOption type="text" id="codigo" inputMode="numeric" maxLength={6} autoComplete="one-time-code"
                           value={values.codigo} onChange={handleChange} onBlur={handleBlur} />
              <Explanation>Caduca en 30 minutos. Revisa la carpeta de spam si no lo ves.</Explanation>
              {errors.codigo && touched.codigo && (<InputError>{errors.codigo}</InputError>)}
            </ContainerOptions>
          </div>
          {result && isFailure(result) && (
            <div className="errorMessage"><p>{result.error?.message ?? result.error ?? 'El código no es correcto.'}</p></div>
          )}
          {resend && isSuccess(resend) && (
            <div className="successMessage text-success"><p>Te hemos enviado un código nuevo.</p></div>
          )}
          {resend && isFailure(resend) && (
            <div className="errorMessage"><p>No se ha podido reenviar el código. Espera unos minutos e inténtalo de nuevo.</p></div>
          )}
          <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-md-end gap-2 submit-row">
            <InputSend type="submit" value="Confirmar código" disabled={result && isPending(result)} />
            <div className="order-md-first text-center">
              <button type="button" className="btn btn-link p-0" onClick={handleResend} disabled={resend && isPending(resend)}>
                {resend && isPending(resend) ? <Spinner size="sm" /> : 'Reenviar código'}
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
